import testListReducer from "./testListReducer";

const testListReducers = {
    testList: testListReducer,
}

export default testListReducers;